module.exports = __webpack_public_path__ + "img/ic-app.b2b0c933.png";